/* @flow */
import Tournaments from "./Tournaments";
import TournamentAccount from "./Account";

function tournamentJoinType({ is_limited, invited, limited_for_money, type }) {
  if (!is_limited) {
    return type; // free | pay
  } else if (invited) {
    return "free";
  } else if (limited_for_money) {
    return "pay";
  } else {
    return "invite"
  }
}

export default Tournaments;
export { TournamentAccount, tournamentJoinType };



// WEBPACK FOOTER //
// ./src/components/Tournaments/index.js